var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_4840_3875",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 18,
    height: 14,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1,
    y: 3,
    width: 18,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8571 4H3.14286C2.51167 4 2 4.53726 2 5.2V14.8C2 15.4627 2.51167 16 3.14286 16H16.8571C17.4883 16 18 15.4627 18 14.8V5.2C18 4.53726 17.4883 4 16.8571 4ZM15.6 5.19996L10 9.26796L4.40002 5.19996H15.6ZM3.14282 14.8V5.74598L9.67425 10.492C9.87013 10.6347 10.1298 10.6347 10.3257 10.492L16.8571 5.74598V14.8H3.14282Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8571 4H3.14286C2.51167 4 2 4.53726 2 5.2V14.8C2 15.4627 2.51167 16 3.14286 16H16.8571C17.4883 16 18 15.4627 18 14.8V5.2C18 4.53726 17.4883 4 16.8571 4ZM15.6 5.19996L10 9.26796L4.40002 5.19996H15.6ZM3.14282 14.8V5.74598L9.67425 10.492C9.87013 10.6347 10.1298 10.6347 10.3257 10.492L16.8571 5.74598V14.8H3.14282Z",
    fill: "#2E3438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 5.19996L15.7176 5.36178L16.2156 4.99996H15.6V5.19996ZM10 9.26796L9.88248 9.42978L10 9.51516L10.1176 9.42978L10 9.26796ZM4.40002 5.19996V4.99996H3.78441L4.28248 5.36178L4.40002 5.19996ZM3.14282 14.8H2.94282V15H3.14282V14.8ZM3.14282 5.74598L3.26039 5.58419L2.94282 5.35343V5.74598H3.14282ZM9.67425 10.492L9.79201 10.3303L9.79182 10.3302L9.67425 10.492ZM10.3257 10.492L10.2081 10.3302L10.2079 10.3303L10.3257 10.492ZM16.8571 5.74598H17.0571V5.35343L16.7395 5.58419L16.8571 5.74598ZM16.8571 14.8V15H17.0571V14.8H16.8571ZM16.8571 3.8H3.14286V4.2H16.8571V3.8ZM3.14286 3.8C2.39213 3.8 1.8 4.43611 1.8 5.2H2.2C2.2 4.63841 2.63121 4.2 3.14286 4.2V3.8ZM1.8 5.2V14.8H2.2V5.2H1.8ZM1.8 14.8C1.8 15.5639 2.39213 16.2 3.14286 16.2V15.8C2.63121 15.8 2.2 15.3616 2.2 14.8H1.8ZM3.14286 16.2H16.8571V15.8H3.14286V16.2ZM16.8571 16.2C17.6079 16.2 18.2 15.5639 18.2 14.8H17.8C17.8 15.3616 17.3688 15.8 16.8571 15.8V16.2ZM18.2 14.8V5.2H17.8V14.8H18.2ZM18.2 5.2C18.2 4.43611 17.6079 3.8 16.8571 3.8V4.2C17.3688 4.2 17.8 4.63841 17.8 5.2H18.2ZM15.4825 5.03815L9.88248 9.10615L10.1176 9.42978L15.7176 5.36178L15.4825 5.03815ZM10.1176 9.10615L4.51757 5.03815L4.28248 5.36178L9.88248 9.42978L10.1176 9.10615ZM4.40002 5.39996H15.6V4.99996H4.40002V5.39996ZM3.34282 14.8V5.74598H2.94282V14.8H3.34282ZM3.02525 5.90778L9.55668 10.6538L9.79182 10.3302L3.26039 5.58419L3.02525 5.90778ZM9.5565 10.6536C9.82256 10.8474 10.1774 10.8474 10.4434 10.6536L10.2079 10.3303C10.0822 10.4219 9.91771 10.4219 9.79201 10.3303L9.5565 10.6536ZM10.4432 10.6538L16.9747 5.90778L16.7395 5.58419L10.2081 10.3302L10.4432 10.6538ZM16.6571 5.74598V14.8H17.0571V5.74598H16.6571ZM16.8571 14.6H3.14282V15H16.8571V14.6Z",
    fill: "#2E3438",
    mask: "url(#path-1-outside-1_4840_3875)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.31e225285b6c06ed67278650b76740de.svg";
export { ForwardRef as ReactComponent };